import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/shared";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        window.history.replaceState({}, "", "/");
        setSession(data.token, data.user);
        toast.success("مرحبًا بك 👋");
        nav("/", { replace: true });
      } catch {
        window.history.replaceState({}, "", "/login");
        toast.error("فشل تسجيل الدخول عبر Google");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setSession]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <Loader />
      <p className="text-[var(--text-muted)] text-sm">جارٍ تسجيل الدخول عبر Google...</p>
    </div>
  );
}
